export const fundmetricRecordConstants = {
  FUNDMETRIC_RECORD_CREATE_LOADING: 'FUNDMETRIC_RECORD_CREATE_LOADING',
  FUNDMETRIC_RECORD_CREATE_SUCCESS: 'FUNDMETRIC_RECORD_CREATE_SUCCESS',
  FUNDMETRIC_RECORD_CREATE_FAILURE: 'FUNDMETRIC_RECORD_CREATE_FAILURE',
  FUNDMETRIC_RECORD_ERROR_RELOAD: 'FUNDMETRIC_RECORD_ERROR_RELOAD',

  FUNDMETRIC_RECORD_LIST_LOADING: 'FUNDMETRIC_RECORD_LIST_LOADING',
  FUNDMETRIC_RECORD_LIST_SUCCESS: 'FUNDMETRIC_RECORD_LIST_SUCCESS',
  FUNDMETRIC_RECORD_LIST_FAILURE: 'FUNDMETRIC_RECORD_LIST_FAILURE',

  FUNDMETRIC_RECORD_EDIT_LOADING: 'FUNDMETRIC_RECORD_EDIT_LOADING',
  FUNDMETRIC_RECORD_EDIT_SUCCESS: 'FUNDMETRIC_RECORD_EDIT_SUCCESS',
  FUNDMETRIC_RECORD_EDIT_FAILURE: 'FUNDMETRIC_RECORD_EDIT_FAILURE',

  FUNDMETRIC_RECORD_DELETE_LOADING: 'FUNDMETRIC_RECORD_DELETE_LOADING',
  FUNDMETRIC_RECORD_DELETE_SUCCESS: 'FUNDMETRIC_RECORD_DELETE_SUCCESS',
  FUNDMETRIC_RECORD_DELETE_FAILURE: 'FUNDMETRIC_RECORD_DELETE_FAILURE'
};
